import { render, staticRenderFns } from "./mailinglist.vue?vue&type=template&id=7dfe9e0c&"
import script from "./mailinglist.vue?vue&type=script&lang=js&"
export * from "./mailinglist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports